import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { err } from "@/utils";
import { useBackendStore, useConfigFiltersStore } from "@/stores";
import ToggleOption from "@/components/settings/ToggleOption.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigListFilters',
  setup(__props) {

const backend = useBackendStore();
const filters = useConfigFiltersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ToggleOption, {
      label: "Owned",
      disabled: !_unref(backend).userLoggedIn,
      tooltip: 
        _unref(backend).userLoggedIn
          ? 'Browse only configurations belonging to you'
          : _unref(err)('Log in to filter by user')
      ,
      modelValue: _unref(filters).owned,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).owned) = $event))
    }, null, 8, ["disabled", "tooltip", "modelValue"])
  ]))
}
}

})